export var SearchDocumentType;
(function (SearchDocumentType) {
    SearchDocumentType["All"] = "all";
    SearchDocumentType["Pages"] = "public/site/pages";
    SearchDocumentType["Products"] = "public/stores/products";
    SearchDocumentType["Blogs"] = "public/blog/posts";
    SearchDocumentType["Forums"] = "public/forum/content";
    SearchDocumentType["Bookings"] = "public/booking/services";
    SearchDocumentType["Events"] = "public/events/events";
    SearchDocumentType["Programs"] = "public/online_programs/programs";
    SearchDocumentType["ProGallery"] = "public/progallery/item";
})(SearchDocumentType || (SearchDocumentType = {}));
export var ForumContentType;
(function (ForumContentType) {
    ForumContentType["Comment"] = "COMMENT";
    ForumContentType["Post"] = "POST";
})(ForumContentType || (ForumContentType = {}));
export var SearchOrderingDirection;
(function (SearchOrderingDirection) {
    SearchOrderingDirection["Ascending"] = "ASC";
    SearchOrderingDirection["Descending"] = "DESC";
})(SearchOrderingDirection || (SearchOrderingDirection = {}));
//# sourceMappingURL=api.types.js.map